import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import QualificationConfigReducer from './slices/QualificationConfig'
import AlertReducer from './slices/Alert'
import AppReducer from './slices/App'
import applicationReducer from './slices/Application'
import assetsReducer from './slices/Assets'
import bookableReducer from './slices/BookableSlots'
import bookingReducer from './slices/Booking'
import applicantReducer from './slices/Applicant'
import filesReducer from './slices/Files'

const store = configureStore({
  reducer: {
    alert: AlertReducer,
    application: applicationReducer,
    booking: bookingReducer,
    app: AppReducer,
    bookableSlots: bookableReducer,
    assets: assetsReducer,
    qualificationConfig: QualificationConfigReducer,
    applicants: applicantReducer,
    files: filesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export default store

export type RootState = ReturnType<typeof store.getState>

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>

export type AppDispatch = typeof store.dispatch
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>()
